import { render, staticRenderFns } from "./AsignacionGlobal.vue?vue&type=template&id=0660d4aa"
import script from "./AsignacionGlobal.vue?vue&type=script&lang=js"
export * from "./AsignacionGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports